import { onBeforeMount, ComponentInstance } from "@vue/composition-api";

const useGetTableLibs = (root: ComponentInstance): void => {
  const store = root.$store;

  onBeforeMount(() => {
    store.dispatch("bugReportView/getStatusesLib");
  });
};

export default useGetTableLibs;
